module.exports = __webpack_public_path__ + "static/media/undertaking_blue.30695139.png";